import { reportRowStatus } from "./week39-report";
import type { PackagingDaySection } from "./week39-view";

/** Hide only verified weekly completion; unplanned and unknown production stays visible. */
export function filterCompletedSections(sections: Map<string, PackagingDaySection[]>, hideCompleted: boolean) {
  if (!hideCompleted) return sections;
  return new Map([...sections].map(([date, lines]) => [date, lines.map((line) => ({
    ...line, rows: line.rows.filter((row) => reportRowStatus(row).tone !== "met"),
  })).filter((line) => line.rows.length > 0)]));
}
